import { EnumStorageTransactionType } from '@Model';
import { Badge, type BadgeVariations } from '@synqo/frontend-component-library';

const TAGS: Record<EnumStorageTransactionType, { text: string; variant: BadgeVariations }> = {
    [EnumStorageTransactionType.Incoming]: { text: '+ ZUGANG', variant: 'success' },
    [EnumStorageTransactionType.Outgoing]: { text: '− ABGANG', variant: 'default' },
    [EnumStorageTransactionType.Stocktaking]: { text: '= INVENTUR', variant: 'info' },
};

/** The tag of a booking's type: + Zugang, − Abgang or = Inventur. */
// @ai-generated 2026-10-30T09:00:00Z by matthias.gessinger@synqony.com using Claude Sonnet 5.5
export function BookingTypeBadge({ type }: { type: EnumStorageTransactionType }) {
    const tag = TAGS[type];
    return <Badge variant={tag.variant}>{tag.text}</Badge>;
}
